module.exports = __webpack_public_path__ + "7cefda62698db98966c0089c96a4b544.png";